import React from "react";
import Image from "components/image";
import Link from "helpers/link";
import pagesSEO from "utils/pages-seo";

const PatioLinks = ({ data: { title, links } }) => (
    <div
        className="bg-white container"
    >
        <div className="flex items-center align-center md:flex-row flex-col">
            <h1 className="w-fit whitespace-nowrap mr-3 md:mb-0 mb-2"> 
                {title}
            </h1>
            <span className="md:w-full w-4/5 md:h-1 h-0.5 bg-yellow-600 max-w-[76.563rem]" />
        </div>
        <div className="flex w-full flex-wrap">
            {links?.map((link) => (
                <Link 
                    className="group flex flex-col md:w-3/12 w-full items-center justify-start p-4"
                    to={link?.image?.url}
                    key={link._key}
                >
                    <Image
                        alt={link?.title}
                        image={link?.image?.asset}
                        className="my-4"
                        title={pagesSEO[link?.image?.url] ? pagesSEO[link?.image?.url]?.title : ""}
                    /> 
                    <div className="w-fit">
                        <p className="w-fit text-blue-700 font-bold uppercase pb-0.5 text-center text-base">
                            {link?.title}
                        </p>
                        <span className="flex h-0.5 bg-blue-700 transition-all duration-300 max-w-0 group-hover:max-w-full" />
                    </div>
                    {link?.subtitle && (
                        <div className="border border-[#666666] rounded-[50px] px-4 mt-4">
                            <p className="text-lg font-semibold text-[#666666]"> 
                                {link?.subtitle}
                            </p>
                        </div>
                    )}
                </Link>
            ))}
        </div>
    </div>
);

export default PatioLinks;
